module.exports = __webpack_public_path__ + "static/media/fleet-data.c452cf40.jpg";